var $ = require('jquery');
var WS = require('../../scripts/ws');
var _throttle = require('lodash/throttle');

$(function () {
    if(!WS.isExperienceEditor()) {
        var $window = $(window),
            $document = $(document),
            $footer = $(".ws-footer"),
            windowHeight = $window.height(),
            contentHeight = $document.height() - ($footer.length ? $footer.height() : 0);
    
        if (contentHeight >= (4 * windowHeight)) {
            var $backToTop = $(".ws-back-to-top"),
                $topFocusElement = $(".ws-main-content"),
                backToTopVisibleClass = "ws-back-to-top--visible",
                invertedFocusClass = "ws-back-to-top--inverted-focus",
                backToTopRequiresFocusStyling = ($footer.length && !$footer.hasClass("ws-footer--simplified")),
                prevScrollPos = $window.scrollTop(),
                hiddenOnDownScroll = false,
                shownOnUpScroll = false,
                scrollThreshold = 20; // distance to be considered a scroll (i.e. ignore subtle trackpad/touch/wheel scrolls)

            /**
             * In most cases, Back to Top patrially or enitrely overlaps blue footer section when displayed via focus.
             * To improve contrast of focus outline, invert the color if at least half of button overlaps footer.
             */
            var setFocusColorStyling = function() {
                if (WS.isFixedElementOverFooter($backToTop, $footer)) {
                    $backToTop.addClass(invertedFocusClass);
                } else {
                    $backToTop.removeClass(invertedFocusClass);
                }
            }
        
            var scrollDirectionHandler = _throttle(function() {
                const currentScrollPos = $window.scrollTop();

                if (backToTopRequiresFocusStyling) {
                    setFocusColorStyling();
                }

                if (currentScrollPos <= windowHeight) {
                    // Always keep Back to Top hidden at top of page
                    if (shownOnUpScroll) {
                        $backToTop.removeClass(backToTopVisibleClass);
                        shownOnUpScroll = false;
                    }
                }
                else {
                    // Detect scroll direction to determine when to hide/show Back to Top
                    if ((currentScrollPos + scrollThreshold) < prevScrollPos) {
                        // Scrolling UP
                        if (!shownOnUpScroll) {
                            $backToTop.addClass(backToTopVisibleClass);
                            hiddenOnDownScroll = false;
                            shownOnUpScroll = true;
                        }
    
                        prevScrollPos = currentScrollPos;
                    }
                    else if ((currentScrollPos - scrollThreshold) > prevScrollPos) {
                        // Scrolling DOWN
                        if (shownOnUpScroll && !hiddenOnDownScroll) {
                            $backToTop.removeClass(backToTopVisibleClass);
                            hiddenOnDownScroll = true;
                            shownOnUpScroll = false;
                        }
                        
                        prevScrollPos = currentScrollPos;
                    }
                }
            }, 200);
        
            $window.on("scroll", scrollDirectionHandler);

            if (backToTopRequiresFocusStyling) {
                $backToTop.on("focus", setFocusColorStyling);
            }
        
            $backToTop.on("click", function(event) {
                event.preventDefault();
        
                // Detach scroll handler during animation
                $window.off("scroll", scrollDirectionHandler);
        
                $backToTop.removeClass(backToTopVisibleClass);
        
                $("html, body").animate(
                    { scrollTop: 0 },
                    0,
                    function() {
                        // Allow the top element to forcibly receive focus
                        $topFocusElement.attr("tabindex", -1);
                        // For accessibility, shift focus to top of page without interrupting smooth scroll
                        $topFocusElement.get(0).focus({preventScroll: true});
        
                        // Reset scroll position
                        prevScrollPos = $window.scrollTop();
        
                        // Reattach scroll event handler
                        $window.on("scroll", scrollDirectionHandler);
                });
            });
        }
    }
});